/* Komodin içerik sayfaları (tema sahibi kod): iletişim modalı ("Bize Ulaşın"), SSS arama süzgeci. */
(function () {
  'use strict';
  var d = document, w = window;
  function qs(s, r) { return (r || d).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  var KT = w.KT || {};
  var openModal = null;
  function setModal(m, on) {
    if (!m) return;
    m.classList.toggle('kt-gizli', !on);
    if (on) { openModal = m; if (KT.lock) KT.lock(); var f = qs('[data-kt-modal-panel]', m) || m; f.focus({ preventScroll: true }); }
    else { if (openModal === m) openModal = null; if (KT.unlock) KT.unlock(); }
  }
  function init() {
    d.addEventListener('click', function (e) {
      var t = e.target;
      var o = t.closest && t.closest('[data-kt-modal-open]');
      if (o) { e.preventDefault(); setModal(qs('[data-kt-modal="' + o.getAttribute('data-kt-modal-open') + '"]'), true); return; }
      var c = t.closest && t.closest('[data-kt-modal-close]');
      if (c) { e.preventDefault(); setModal(c.closest('[data-kt-modal]'), false); }
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openModal) setModal(openModal, false); });
    qsa('[data-kt-modal]').forEach(function (m) { if (!m.classList.contains('kt-gizli')) { openModal = m; if (KT.lock) KT.lock(); } });

    var inp = qs('[data-kt-faq-search]'), box = qs('[data-kt-faq]');
    if (inp && box) {
      var empty = qs('[data-kt-faq-empty]', box);
      function norm(s) { return (s || '').toLocaleLowerCase('tr-TR'); }
      inp.addEventListener('input', function () {
        var q = norm(inp.value.trim()), any = false;
        qsa('[data-kt-faq-group]', box).forEach(function (g) {
          var shown = 0;
          qsa('[data-kt-faq-item]', g).forEach(function (it) {
            var hit = !q || norm(it.textContent).indexOf(q) >= 0;
            it.classList.toggle('kt-gizli', !hit); if (hit) shown++;
            if (q && hit) it.open = true; else if (!q) it.open = false;
          });
          g.classList.toggle('kt-gizli', !shown); if (shown) any = true;
        });
        if (empty) empty.classList.toggle('kt-gizli', any);
      });
    }
  }
  if (KT.register) KT.register(init);
  else if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
